module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-BoldItalic.9dbe7a6b.otf";